"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreAddress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const StoreAddress = ({ address }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${address.street} ${address.number}`, address.bus && ` ${address.bus}`, (0, jsx_runtime_1.jsx)("br", {}), `${address.zipCode} ${address.city}`] }));
exports.StoreAddress = StoreAddress;
